(function(){"use strict";try{if(typeof document<"u"){var r=document.createElement("style");r.appendChild(document.createTextNode("._errorWrapper_171rr_1{word-break:break-word}._copyIcon_171rr_5{cursor:pointer;color:var(--dixa-typography-color-secondary)}._settingsWrapper_eleyu_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);margin-bottom:var(--dixa-size-spacer-300)}")),document.head.appendChild(r)}}catch(e){console.error("vite-plugin-css-injected-by-js",e)}})();
import { useQuery as Gr, useLazyQuery as Vr, useMutation as Yr, isApolloError as Kr, gql as Pe } from "@apollo/client";
import { __extends as Hr } from "tslib";
import sr, { useState as I, useEffect as M, createContext as Jr, useContext as qr } from "react";
import { FormField as te, FieldWrapper as z, Badge as Ne, Icon as Ie, FlexBox as W, Text as ne, List as Ze, Banner as zr, Button as De, Tooltip as Qr, Spinner as cr, FieldSwitch as Zr, InputSelectionList as Xr, SelectionList as et } from "@dixa/lib-shared-habla";
import { Link as rt } from "react-router-dom";
import { colors as B } from "@dixa/lib-shared-tokens";
import { useInterval as tt } from "react-use";
import nt from "moment";
var we = "Invariant Violation", Xe = Object.setPrototypeOf, ot = Xe === void 0 ? function(r, t) {
  return r.__proto__ = t, r;
} : Xe, at = (
  /** @class */
  (function(r) {
    Hr(t, r);
    function t(a) {
      a === void 0 && (a = we);
      var i = r.call(this, typeof a == "number" ? we + ": " + a + " (see https://github.com/apollographql/invariant-packages)" : a) || this;
      return i.framesToPop = 1, i.name = we, ot(i, t.prototype), i;
    }
    return t;
  })(Error)
);
function V(r, t) {
  if (!r)
    throw new at(t);
}
var lr = ["debug", "log", "warn", "error", "silent"], it = lr.indexOf("log");
function de(r) {
  return function() {
    if (lr.indexOf(r) >= it) {
      var t = console[r] || console.log;
      return t.apply(console, arguments);
    }
  };
}
(function(r) {
  r.debug = de("debug"), r.log = de("log"), r.warn = de("warn"), r.error = de("error");
})(V || (V = {}));
var ur = "3.14.0";
function q(r) {
  try {
    return r();
  } catch {
  }
}
const er = q(function() {
  return globalThis;
}) || q(function() {
  return window;
}) || q(function() {
  return self;
}) || q(function() {
  return global;
}) || // We don't expect the Function constructor ever to be invoked at runtime, as
// long as at least one of globalThis, window, self, or global is defined, so
// we are under no obligation to make it easy for static analysis tools to
// detect syntactic usage of the Function constructor. If you think you can
// improve your static analysis to detect this obfuscation, think again. This
// is an arms race you cannot win, at least not in JavaScript.
q(function() {
  return q.constructor("return this")();
});
var rr = /* @__PURE__ */ new Map();
function st(r) {
  var t = rr.get(r) || 1;
  return rr.set(r, t + 1), "".concat(r, ":").concat(t, ":").concat(Math.random().toString(36).slice(2));
}
function ct(r, t) {
  var a = st("stringifyForDisplay");
  return JSON.stringify(r, function(i, u) {
    return u === void 0 ? a : u;
  }, t).split(JSON.stringify(a)).join("<undefined>");
}
function pe(r) {
  return function(t) {
    for (var a = [], i = 1; i < arguments.length; i++)
      a[i - 1] = arguments[i];
    if (typeof t == "number") {
      var u = t;
      t = dr(u), t || (t = pr(u, a), a = []);
    }
    r.apply(void 0, [t].concat(a));
  };
}
Object.assign(function(t, a) {
  for (var i = [], u = 2; u < arguments.length; u++)
    i[u - 2] = arguments[u];
  t || V(t, dr(a, i) || pr(a, i));
}, {
  debug: pe(V.debug),
  log: pe(V.log),
  warn: pe(V.warn),
  error: pe(V.error)
});
var tr = Symbol.for("ApolloErrorMessageHandler_" + ur);
function fr(r) {
  if (typeof r == "string")
    return r;
  try {
    return ct(r, 2).slice(0, 1e3);
  } catch {
    return "<non-serializable>";
  }
}
function dr(r, t) {
  if (t === void 0 && (t = []), !!r)
    return er[tr] && er[tr](r, t.map(fr));
}
function pr(r, t) {
  if (t === void 0 && (t = []), !!r)
    return "An error occurred! For more details, see the full error text at https://go.apollo.dev/c/err#".concat(encodeURIComponent(JSON.stringify({
      version: ur,
      message: r,
      args: t.map(fr)
    })));
}
function ge(r) {
  return r.definitions.filter(function(t) {
    return t.kind === "OperationDefinition" && !!t.name;
  }).map(function(t) {
    return t.name.value;
  })[0] || null;
}
const Kt = (r, t) => function(a, i) {
  return Gr(a, {
    ...i,
    context: {
      operationName: ge(a),
      ...i?.context,
      widgetId: r,
      widgetType: t
    }
  });
}, Ht = (r, t) => function(a, i) {
  return Vr(a, {
    ...i,
    context: {
      operationName: ge(a),
      ...i?.context,
      widgetId: r,
      widgetType: t
    }
  });
}, Jt = (r, t, a) => function(i, u) {
  return a.query({
    query: i,
    variables: u,
    context: {
      operationName: ge(i),
      widgetId: r,
      widgetType: t
    }
  });
}, qt = (r, t) => function(a, i) {
  return Yr(a, {
    ...i,
    context: {
      operationName: ge(a),
      ...i?.context,
      widgetId: r,
      widgetType: t
    }
  });
};
var ve = { exports: {} }, ee = {};
var nr;
function lt() {
  if (nr) return ee;
  nr = 1;
  var r = sr, t = Symbol.for("react.element"), a = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, u = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, m = { key: !0, ref: !0, __self: !0, __source: !0 };
  function C(x, g, O) {
    var p, E = {}, S = null, T = null;
    O !== void 0 && (S = "" + O), g.key !== void 0 && (S = "" + g.key), g.ref !== void 0 && (T = g.ref);
    for (p in g) i.call(g, p) && !m.hasOwnProperty(p) && (E[p] = g[p]);
    if (x && x.defaultProps) for (p in g = x.defaultProps, g) E[p] === void 0 && (E[p] = g[p]);
    return { $$typeof: t, type: x, key: S, ref: T, props: E, _owner: u.current };
  }
  return ee.Fragment = a, ee.jsx = C, ee.jsxs = C, ee;
}
var re = {};
var or;
function ut() {
  return or || (or = 1, process.env.NODE_ENV !== "production" && (function() {
    var r = sr, t = Symbol.for("react.element"), a = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), u = Symbol.for("react.strict_mode"), m = Symbol.for("react.profiler"), C = Symbol.for("react.provider"), x = Symbol.for("react.context"), g = Symbol.for("react.forward_ref"), O = Symbol.for("react.suspense"), p = Symbol.for("react.suspense_list"), E = Symbol.for("react.memo"), S = Symbol.for("react.lazy"), T = Symbol.for("react.offscreen"), P = Symbol.iterator, w = "@@iterator";
    function N(e) {
      if (e === null || typeof e != "object")
        return null;
      var n = P && e[P] || e[w];
      return typeof n == "function" ? n : null;
    }
    var d = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function b(e) {
      {
        for (var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), c = 1; c < n; c++)
          o[c - 1] = arguments[c];
        $("error", e, o);
      }
    }
    function $(e, n, o) {
      {
        var c = d.ReactDebugCurrentFrame, v = c.getStackAddendum();
        v !== "" && (n += "%s", o = o.concat([v]));
        var h = o.map(function(f) {
          return String(f);
        });
        h.unshift("Warning: " + n), Function.prototype.apply.call(console[e], console, h);
      }
    }
    var Q = !1, he = !1, me = !1, Y = !1, Ee = !1, oe;
    oe = Symbol.for("react.module.reference");
    function ae(e) {
      return !!(typeof e == "string" || typeof e == "function" || e === i || e === m || Ee || e === u || e === O || e === p || Y || e === T || Q || he || me || typeof e == "object" && e !== null && (e.$$typeof === S || e.$$typeof === E || e.$$typeof === C || e.$$typeof === x || e.$$typeof === g || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      e.$$typeof === oe || e.getModuleId !== void 0));
    }
    function ye(e, n, o) {
      var c = e.displayName;
      if (c)
        return c;
      var v = n.displayName || n.name || "";
      return v !== "" ? o + "(" + v + ")" : o;
    }
    function K(e) {
      return e.displayName || "Context";
    }
    function k(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && b("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case i:
          return "Fragment";
        case a:
          return "Portal";
        case m:
          return "Profiler";
        case u:
          return "StrictMode";
        case O:
          return "Suspense";
        case p:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case x:
            var n = e;
            return K(n) + ".Consumer";
          case C:
            var o = e;
            return K(o._context) + ".Provider";
          case g:
            return ye(e, e.render, "ForwardRef");
          case E:
            var c = e.displayName || null;
            return c !== null ? c : k(e.type) || "Memo";
          case S: {
            var v = e, h = v._payload, f = v._init;
            try {
              return k(f(h));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var F = Object.assign, y = 0, L, U, Z, ie, se, je, ke;
    function Me() {
    }
    Me.__reactDisabledLog = !0;
    function hr() {
      {
        if (y === 0) {
          L = console.log, U = console.info, Z = console.warn, ie = console.error, se = console.group, je = console.groupCollapsed, ke = console.groupEnd;
          var e = {
            configurable: !0,
            enumerable: !0,
            value: Me,
            writable: !0
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        y++;
      }
    }
    function mr() {
      {
        if (y--, y === 0) {
          var e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: F({}, e, {
              value: L
            }),
            info: F({}, e, {
              value: U
            }),
            warn: F({}, e, {
              value: Z
            }),
            error: F({}, e, {
              value: ie
            }),
            group: F({}, e, {
              value: se
            }),
            groupCollapsed: F({}, e, {
              value: je
            }),
            groupEnd: F({}, e, {
              value: ke
            })
          });
        }
        y < 0 && b("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ce = d.ReactCurrentDispatcher, be;
    function ce(e, n, o) {
      {
        if (be === void 0)
          try {
            throw Error();
          } catch (v) {
            var c = v.stack.trim().match(/\n( *(at )?)/);
            be = c && c[1] || "";
          }
        return `
` + be + e;
      }
    }
    var Re = !1, le;
    {
      var Er = typeof WeakMap == "function" ? WeakMap : Map;
      le = new Er();
    }
    function Fe(e, n) {
      if (!e || Re)
        return "";
      {
        var o = le.get(e);
        if (o !== void 0)
          return o;
      }
      var c;
      Re = !0;
      var v = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var h;
      h = Ce.current, Ce.current = null, hr();
      try {
        if (n) {
          var f = function() {
            throw Error();
          };
          if (Object.defineProperty(f.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(f, []);
            } catch (D) {
              c = D;
            }
            Reflect.construct(e, [], f);
          } else {
            try {
              f.call();
            } catch (D) {
              c = D;
            }
            e.call(f.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (D) {
            c = D;
          }
          e();
        }
      } catch (D) {
        if (D && c && typeof D.stack == "string") {
          for (var l = D.stack.split(`
`), A = c.stack.split(`
`), R = l.length - 1, _ = A.length - 1; R >= 1 && _ >= 0 && l[R] !== A[_]; )
            _--;
          for (; R >= 1 && _ >= 0; R--, _--)
            if (l[R] !== A[_]) {
              if (R !== 1 || _ !== 1)
                do
                  if (R--, _--, _ < 0 || l[R] !== A[_]) {
                    var j = `
` + l[R].replace(" at new ", " at ");
                    return e.displayName && j.includes("<anonymous>") && (j = j.replace("<anonymous>", e.displayName)), typeof e == "function" && le.set(e, j), j;
                  }
                while (R >= 1 && _ >= 0);
              break;
            }
        }
      } finally {
        Re = !1, Ce.current = h, mr(), Error.prepareStackTrace = v;
      }
      var J = e ? e.displayName || e.name : "", G = J ? ce(J) : "";
      return typeof e == "function" && le.set(e, G), G;
    }
    function yr(e, n, o) {
      return Fe(e, !1);
    }
    function Cr(e) {
      var n = e.prototype;
      return !!(n && n.isReactComponent);
    }
    function ue(e, n, o) {
      if (e == null)
        return "";
      if (typeof e == "function")
        return Fe(e, Cr(e));
      if (typeof e == "string")
        return ce(e);
      switch (e) {
        case O:
          return ce("Suspense");
        case p:
          return ce("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case g:
            return yr(e.render);
          case E:
            return ue(e.type, n, o);
          case S: {
            var c = e, v = c._payload, h = c._init;
            try {
              return ue(h(v), n, o);
            } catch {
            }
          }
        }
      return "";
    }
    var X = Object.prototype.hasOwnProperty, Le = {}, We = d.ReactDebugCurrentFrame;
    function fe(e) {
      if (e) {
        var n = e._owner, o = ue(e.type, e._source, n ? n.type : null);
        We.setExtraStackFrame(o);
      } else
        We.setExtraStackFrame(null);
    }
    function br(e, n, o, c, v) {
      {
        var h = Function.call.bind(X);
        for (var f in e)
          if (h(e, f)) {
            var l = void 0;
            try {
              if (typeof e[f] != "function") {
                var A = Error((c || "React class") + ": " + o + " type `" + f + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[f] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw A.name = "Invariant Violation", A;
              }
              l = e[f](n, f, c, o, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (R) {
              l = R;
            }
            l && !(l instanceof Error) && (fe(v), b("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", c || "React class", o, f, typeof l), fe(null)), l instanceof Error && !(l.message in Le) && (Le[l.message] = !0, fe(v), b("Failed %s type: %s", o, l.message), fe(null));
          }
      }
    }
    var Rr = Array.isArray;
    function _e(e) {
      return Rr(e);
    }
    function _r(e) {
      {
        var n = typeof Symbol == "function" && Symbol.toStringTag, o = n && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return o;
      }
    }
    function Tr(e) {
      try {
        return $e(e), !1;
      } catch {
        return !0;
      }
    }
    function $e(e) {
      return "" + e;
    }
    function Ue(e) {
      if (Tr(e))
        return b("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", _r(e)), $e(e);
    }
    var Be = d.ReactCurrentOwner, xr = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ge, Ve;
    function Or(e) {
      if (X.call(e, "ref")) {
        var n = Object.getOwnPropertyDescriptor(e, "ref").get;
        if (n && n.isReactWarning)
          return !1;
      }
      return e.ref !== void 0;
    }
    function Sr(e) {
      if (X.call(e, "key")) {
        var n = Object.getOwnPropertyDescriptor(e, "key").get;
        if (n && n.isReactWarning)
          return !1;
      }
      return e.key !== void 0;
    }
    function wr(e, n) {
      typeof e.ref == "string" && Be.current;
    }
    function Ar(e, n) {
      {
        var o = function() {
          Ge || (Ge = !0, b("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", n));
        };
        o.isReactWarning = !0, Object.defineProperty(e, "key", {
          get: o,
          configurable: !0
        });
      }
    }
    function Nr(e, n) {
      {
        var o = function() {
          Ve || (Ve = !0, b("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", n));
        };
        o.isReactWarning = !0, Object.defineProperty(e, "ref", {
          get: o,
          configurable: !0
        });
      }
    }
    var Dr = function(e, n, o, c, v, h, f) {
      var l = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: e,
        key: n,
        ref: o,
        props: f,
        // Record the component responsible for creating this element.
        _owner: h
      };
      return l._store = {}, Object.defineProperty(l._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(l, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: c
      }), Object.defineProperty(l, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: v
      }), Object.freeze && (Object.freeze(l.props), Object.freeze(l)), l;
    };
    function Pr(e, n, o, c, v) {
      {
        var h, f = {}, l = null, A = null;
        o !== void 0 && (Ue(o), l = "" + o), Sr(n) && (Ue(n.key), l = "" + n.key), Or(n) && (A = n.ref, wr(n, v));
        for (h in n)
          X.call(n, h) && !xr.hasOwnProperty(h) && (f[h] = n[h]);
        if (e && e.defaultProps) {
          var R = e.defaultProps;
          for (h in R)
            f[h] === void 0 && (f[h] = R[h]);
        }
        if (l || A) {
          var _ = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
          l && Ar(f, _), A && Nr(f, _);
        }
        return Dr(e, l, A, v, c, Be.current, f);
      }
    }
    var Te = d.ReactCurrentOwner, Ye = d.ReactDebugCurrentFrame;
    function H(e) {
      if (e) {
        var n = e._owner, o = ue(e.type, e._source, n ? n.type : null);
        Ye.setExtraStackFrame(o);
      } else
        Ye.setExtraStackFrame(null);
    }
    var xe;
    xe = !1;
    function Oe(e) {
      return typeof e == "object" && e !== null && e.$$typeof === t;
    }
    function Ke() {
      {
        if (Te.current) {
          var e = k(Te.current.type);
          if (e)
            return `

Check the render method of \`` + e + "`.";
        }
        return "";
      }
    }
    function Ir(e) {
      return "";
    }
    var He = {};
    function jr(e) {
      {
        var n = Ke();
        if (!n) {
          var o = typeof e == "string" ? e : e.displayName || e.name;
          o && (n = `

Check the top-level render call using <` + o + ">.");
        }
        return n;
      }
    }
    function Je(e, n) {
      {
        if (!e._store || e._store.validated || e.key != null)
          return;
        e._store.validated = !0;
        var o = jr(n);
        if (He[o])
          return;
        He[o] = !0;
        var c = "";
        e && e._owner && e._owner !== Te.current && (c = " It was passed a child from " + k(e._owner.type) + "."), H(e), b('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', o, c), H(null);
      }
    }
    function qe(e, n) {
      {
        if (typeof e != "object")
          return;
        if (_e(e))
          for (var o = 0; o < e.length; o++) {
            var c = e[o];
            Oe(c) && Je(c, n);
          }
        else if (Oe(e))
          e._store && (e._store.validated = !0);
        else if (e) {
          var v = N(e);
          if (typeof v == "function" && v !== e.entries)
            for (var h = v.call(e), f; !(f = h.next()).done; )
              Oe(f.value) && Je(f.value, n);
        }
      }
    }
    function kr(e) {
      {
        var n = e.type;
        if (n == null || typeof n == "string")
          return;
        var o;
        if (typeof n == "function")
          o = n.propTypes;
        else if (typeof n == "object" && (n.$$typeof === g || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        n.$$typeof === E))
          o = n.propTypes;
        else
          return;
        if (o) {
          var c = k(n);
          br(o, e.props, "prop", c, e);
        } else if (n.PropTypes !== void 0 && !xe) {
          xe = !0;
          var v = k(n);
          b("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", v || "Unknown");
        }
        typeof n.getDefaultProps == "function" && !n.getDefaultProps.isReactClassApproved && b("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Mr(e) {
      {
        for (var n = Object.keys(e.props), o = 0; o < n.length; o++) {
          var c = n[o];
          if (c !== "children" && c !== "key") {
            H(e), b("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", c), H(null);
            break;
          }
        }
        e.ref !== null && (H(e), b("Invalid attribute `ref` supplied to `React.Fragment`."), H(null));
      }
    }
    var ze = {};
    function Qe(e, n, o, c, v, h) {
      {
        var f = ae(e);
        if (!f) {
          var l = "";
          (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (l += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var A = Ir();
          A ? l += A : l += Ke();
          var R;
          e === null ? R = "null" : _e(e) ? R = "array" : e !== void 0 && e.$$typeof === t ? (R = "<" + (k(e.type) || "Unknown") + " />", l = " Did you accidentally export a JSX literal instead of a component?") : R = typeof e, b("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", R, l);
        }
        var _ = Pr(e, n, o, v, h);
        if (_ == null)
          return _;
        if (f) {
          var j = n.children;
          if (j !== void 0)
            if (c)
              if (_e(j)) {
                for (var J = 0; J < j.length; J++)
                  qe(j[J], e);
                Object.freeze && Object.freeze(j);
              } else
                b("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              qe(j, e);
        }
        if (X.call(n, "key")) {
          var G = k(e), D = Object.keys(n).filter(function(Br) {
            return Br !== "key";
          }), Se = D.length > 0 ? "{key: someKey, " + D.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!ze[G + Se]) {
            var Ur = D.length > 0 ? "{" + D.join(": ..., ") + ": ...}" : "{}";
            b(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Se, G, Ur, G), ze[G + Se] = !0;
          }
        }
        return e === i ? Mr(_) : kr(_), _;
      }
    }
    function Fr(e, n, o) {
      return Qe(e, n, o, !0);
    }
    function Lr(e, n, o) {
      return Qe(e, n, o, !1);
    }
    var Wr = Lr, $r = Fr;
    re.Fragment = i, re.jsx = Wr, re.jsxs = $r;
  })()), re;
}
var ar;
function ft() {
  return ar || (ar = 1, process.env.NODE_ENV === "production" ? ve.exports = lt() : ve.exports = ut()), ve.exports;
}
var s = ft();
const zt = ({
  getValueByKey: r
}) => {
  const t = r("dixaApiTokenId")?.value, a = r("dixaApiTokenName")?.value;
  return /* @__PURE__ */ s.jsx(te, { children: /* @__PURE__ */ s.jsx(z, { label: "Dixa API-Token", children: !a || !t ? /* @__PURE__ */ s.jsx(s.Fragment, { children: "Something seems odd with the Api-Token. No name and/or id available." }) : /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    "A Dixa Token with the name",
    " ",
    /* @__PURE__ */ s.jsx(Ne, { variant: "secondary", size: "small", children: a }),
    " ",
    "was created.",
    " ",
    /* @__PURE__ */ s.jsx(rt, { to: `/settings/integrations/api-tokens/${t}`, children: "You can visit it on the Api-Token page" }),
    "."
  ] }) }) });
}, dt = ({
  error: r
}) => r.extensions?.integration?.code === "DIXA_HEADER_CHECK_ERROR", Qt = ({
  errors: r
}) => r.some((t) => dt({ error: t })), pt = ({
  error: r
}) => r.extensions?.integration?.code === "DOWNSTREAM_API_AUTHORIZATION_ERROR", Zt = ({
  errors: r
}) => r.some((t) => pt({ error: t })), vt = ({
  error: r
}) => r.extensions?.integration?.code === "DOWNSTREAM_API_PERMISSION_ERROR", Xt = ({
  errors: r
}) => r.some((t) => vt({ error: t })), gt = ({
  error: r
}) => r.extensions?.integration?.code === "DOWNSTREAM_API_SERVICE_UNAVAILABLE_ERROR", en = ({
  errors: r
}) => r.some((t) => gt({ error: t })), ht = ({
  error: r
}) => r.extensions?.integration?.code === "DOWNSTREAM_API_NOT_FOUND_ERROR", rn = ({
  errors: r
}) => r.some((t) => ht({ error: t })), mt = ({
  error: r
}) => r.extensions?.integration?.code === "DOWNSTREAM_API_CONFLICT_ERROR", tn = ({
  errors: r
}) => r.some((t) => mt({ error: t })), Et = ({
  error: r
}) => r.extensions?.integration?.code === "DOWNSTREAM_API_BAD_REQUEST_ERROR", nn = ({
  errors: r
}) => r.some((t) => Et({ error: t })), yt = ({
  error: r
}) => r.extensions?.integration?.code === "DOWNSTREAM_API_FORBIDDEN_ERROR", on = ({
  errors: r
}) => r.some((t) => yt({ error: t })), Ct = ({
  error: r
}) => r.extensions?.integration?.code === "DOWNSTREAM_API_TOO_MANY_REQUESTS_ERROR", an = ({
  errors: r
}) => r.some((t) => Ct({ error: t })), bt = ({
  error: r
}) => r.extensions?.integration?.code === "WIDGET_MISCONFIGURED_ERROR", Rt = ({
  errors: r
}) => r.some((t) => bt({ error: t })), _t = (r) => {
  const { delay: t = 2e3 } = r || {}, [a, i] = I(!1);
  return M(() => {
    const m = a ? window.setTimeout(() => i(!1), t) : void 0;
    return () => window.clearTimeout(m);
  }, [t, a]), { isCopied: a, copy: (m) => {
    navigator.clipboard.writeText(m), i(!0);
  } };
}, Tt = "_errorWrapper_171rr_1", xt = "_copyIcon_171rr_5", Ae = {
  errorWrapper: Tt,
  copyIcon: xt
}, Ot = ({
  error: r,
  retry: t,
  isMisconfigured: a = !1
}) => {
  const u = r && Kr(r) && r?.graphQLErrors?.length > 0, { isCopied: m, copy: C } = _t(), x = /* @__PURE__ */ s.jsx(
    Ie,
    {
      color: B.red[500],
      size: 16,
      name: "exclamation-triangle-filled"
    }
  );
  if (a || u && Rt({
    errors: r.graphQLErrors
  }))
    return /* @__PURE__ */ s.jsxs(W, { margin: "0 0 100", padding: "200", className: Ae.errorWrapper, children: [
      /* @__PURE__ */ s.jsx(W, { margin: "0 300 0 0", alignItems: "center", children: x }),
      /* @__PURE__ */ s.jsx(ne.Paragraph, { color: "secondary", children: "This integration is not properly configured and could not be loaded. Please contact your administrator." })
    ] });
  if (!u)
    return /* @__PURE__ */ s.jsx(W, { margin: "200 0", flexDirection: "column", children: /* @__PURE__ */ s.jsx(
      Ze.Item,
      {
        contentLeft: x,
        title: "Something went wrong. Please try again later.",
        variant: "dense"
      }
    ) });
  const g = r?.graphQLErrors || [];
  return /* @__PURE__ */ s.jsxs(
    W,
    {
      margin: "200 0 300",
      flexDirection: "column",
      className: Ae.errorWrapper,
      children: [
        g.map((O, p) => {
          const E = O?.extensions?.integration, S = E?.message || r?.message || "No error message available", T = E?.responseBody && JSON.parse(E?.responseBody), P = T?.errorMessages || [], w = T?.warningMessages || [], N = [...P, ...w].join(" ");
          return /* @__PURE__ */ s.jsx(
            Ze.Item,
            {
              title: S,
              titleSecondary: N,
              contentLeft: x
            },
            p
          );
        }),
        /* @__PURE__ */ s.jsxs(W, { margin: "200 0 300", flexDirection: "column", gap: "200", children: [
          /* @__PURE__ */ s.jsx(
            zr,
            {
              variant: "info",
              description: /* @__PURE__ */ s.jsx(ne.Paragraph, { variant: "4", children: "Please copy the error details by clicking on the button below and include them in your support request." })
            }
          ),
          /* @__PURE__ */ s.jsxs(W, { flexDirection: "row", gap: "200", justifyContent: "space-between", children: [
            t && /* @__PURE__ */ s.jsx(De, { variant: "secondary", icon: "sync", onClick: () => t(), children: "Retry" }),
            /* @__PURE__ */ s.jsx(
              De,
              {
                variant: "secondary",
                icon: m ? "done" : "copy",
                onClick: () => C(JSON.stringify(g, null, 2)),
                className: Ae.copyIcon,
                children: "Copy error payload"
              }
            )
          ] })
        ] })
      ]
    }
  );
};
function sn(r, t = !0) {
  try {
    return JSON.parse(JSON.stringify(r));
  } catch {
    return t && console.error(`Could not make a copy of ${JSON.stringify(r)}`), {};
  }
}
const cn = (r) => `${r.charAt(0).toUpperCase()}${r.slice(1).toLowerCase()}`, St = "DD MMM YYYY @ HH:mm";
function ln(r) {
  try {
    return new Intl.DisplayNames(["en"], { type: "region" }).of(
      r.toUpperCase()
    ) ?? r;
  } catch {
    return r;
  }
}
const un = [
  "AF",
  "AX",
  "AL",
  "DZ",
  "AD",
  "AO",
  "AI",
  "AG",
  "AR",
  "AM",
  "AW",
  "AC",
  "AU",
  "AT",
  "AZ",
  "BS",
  "BH",
  "BD",
  "BB",
  "BY",
  "BE",
  "BZ",
  "BJ",
  "BM",
  "BT",
  "BO",
  "BA",
  "BW",
  "BV",
  "BR",
  "IO",
  "BN",
  "BG",
  "BF",
  "BI",
  "KH",
  "CA",
  "CV",
  "BQ",
  "KY",
  "CF",
  "TD",
  "CL",
  "CN",
  "CX",
  "CC",
  "CO",
  "KM",
  "CG",
  "CD",
  "CK",
  "CR",
  "HR",
  "CU",
  "CW",
  "CY",
  "CZ",
  "CI",
  "DK",
  "DJ",
  "DM",
  "DO",
  "EC",
  "EG",
  "SV",
  "GQ",
  "ER",
  "EE",
  "SZ",
  "ET",
  "FK",
  "FO",
  "FJ",
  "FI",
  "FR",
  "GF",
  "PF",
  "TF",
  "GA",
  "GM",
  "GE",
  "DE",
  "GH",
  "GI",
  "GR",
  "GL",
  "GD",
  "GP",
  "GT",
  "GG",
  "GN",
  "GW",
  "GY",
  "HT",
  "HM",
  "VA",
  "HN",
  "HK",
  "HU",
  "IS",
  "IN",
  "ID",
  "IR",
  "IQ",
  "IE",
  "IM",
  "IL",
  "IT",
  "JM",
  "JP",
  "JE",
  "JO",
  "KZ",
  "KE",
  "KI",
  "KP",
  "XK",
  "KW",
  "KG",
  "LA",
  "LV",
  "LB",
  "LS",
  "LR",
  "LY",
  "LI",
  "LT",
  "LU",
  "MO",
  "MG",
  "MW",
  "MY",
  "MV",
  "ML",
  "MT",
  "MQ",
  "MR",
  "MU",
  "YT",
  "MX",
  "MD",
  "MC",
  "MN",
  "ME",
  "MS",
  "MA",
  "MZ",
  "MM",
  "NA",
  "NR",
  "NP",
  "NL",
  "AN",
  "NC",
  "NZ",
  "NI",
  "NE",
  "NG",
  "NU",
  "NF",
  "MK",
  "NO",
  "OM",
  "PK",
  "PS",
  "PA",
  "PG",
  "PY",
  "PE",
  "PH",
  "PN",
  "PL",
  "PT",
  "QA",
  "CM",
  "RE",
  "RO",
  "RU",
  "RW",
  "BL",
  "SH",
  "KN",
  "LC",
  "MF",
  "PM",
  "WS",
  "SM",
  "ST",
  "SA",
  "SN",
  "RS",
  "SC",
  "SL",
  "SG",
  "SX",
  "SK",
  "SI",
  "SB",
  "SO",
  "ZA",
  "GS",
  "KR",
  "SS",
  "ES",
  "LK",
  "VC",
  "SD",
  "SR",
  "SJ",
  "SE",
  "CH",
  "SY",
  "TW",
  "TJ",
  "TZ",
  "TH",
  "TL",
  "TG",
  "TK",
  "TO",
  "TT",
  "TA",
  "TN",
  "TR",
  "TM",
  "TC",
  "TV",
  "UG",
  "UA",
  "AE",
  "GB",
  "US",
  "UM",
  "UY",
  "UZ",
  "VU",
  "VE",
  "VN",
  "VG",
  "WF",
  "EH",
  "YE",
  "ZM",
  "ZW",
  "ZZ"
], fn = (r) => {
  if (!r?.trim())
    return "Please add a valid subdomain";
  const a = ["https://", "http://"].find(
    (m) => r.startsWith(m)
  ), i = a ? `Please remove the protocol \`${a}\` from the hostname` : "", u = r.endsWith("/") ? "Please remove the trailing `/` from the hostname" : "";
  if (i && u)
    return `Please remove the protocol \`${a}\` and the trailing \`/\` from the hostname`;
  if (i)
    return i;
  if (u)
    return u;
};
function wt(r) {
  const t = r.split(".")[1];
  if (!t)
    throw Error("Invalid token");
  const a = t.replace(/-/g, "+").replace(/_/g, "/");
  try {
    return JSON.parse(atob(a).toString());
  } catch (i) {
    throw Error(
      `Failed to parse the JSON Web Token with the following error: ${i}`
    );
  }
}
function At(r) {
  const { user_id: t, iss: a } = wt(r);
  return {
    "x-integration-user-id": t,
    "x-integration-organization-id": a
  };
}
function Nt(r) {
  return r.startsWith("http://localhost");
}
function Dt() {
  return { track: (t, a) => window._partner.events.emit(t, a) };
}
const Pt = (r) => {
  switch (r) {
    case "CONNECTED":
      return {
        icon: "check-circle-filled",
        color: B.green[500],
        tooltip: "Connected"
      };
    case "CONNECTING":
      return {
        icon: "sync",
        color: B.neutral[500],
        tooltip: "Connecting.."
      };
    case "CONNECTION_FAILED":
      return {
        icon: "close-circle-filled",
        color: B.red[500],
        tooltip: "Connection failed"
      };
    case "CONNECTION_TIMEOUT":
      return {
        icon: "exclamation-triangle-filled",
        color: B.red[200],
        tooltip: "Connection timeout"
      };
    case "NOT_CONNECTED":
    default:
      return {
        icon: "exclamation-circle-filled",
        color: B.neutral[500],
        tooltip: "Not connected"
      };
  }
}, dn = ({
  configuration: r,
  integrationId: t,
  integrationType: a,
  label: i
}) => {
  const [u, m] = I("CONNECTING"), { track: C } = Dt(), { icon: x, color: g, tooltip: O } = Pt(u), p = 3, E = 15, S = 2e3, [T, P] = I({}), [w, N] = I(0), [d, b] = I(S), [$, Q] = I(!1), [he, me] = I(p), { baseUrl: Y } = r, Ee = `${Y}/auth/connect/${a.toLowerCase()}/${t}`, oe = `${Y}/auth/status/${a.toLowerCase()}/${t}`, ae = u === "CONNECTING", ye = (y) => Object.keys(y).length === 0, K = () => {
    Q(!1), N(0);
  };
  M(() => {
    const y = localStorage.getItem("authData");
    if (y) {
      const U = JSON.parse(y ?? "{}").access_token;
      P({
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: `Bearer ${U}`,
          ...Nt(Y) && At(U)
        }
      });
    }
  }, [Y]), M(() => {
    ye(T) || Q(!0);
  }, [T]);
  const k = () => {
    me(E), fetch(oe, { ...T }).then((y) => y.json()).then(({ data: y }) => {
      const { status: L } = y;
      L === "CONNECTING" && m("CONNECTING"), L === "CONNECTED" && (C("settings:view:oauth:succeeded", {
        widgetId: t,
        widgetType: a
      }), m("CONNECTED"), K()), L === "NOT_CONNECTED" && (m("NOT_CONNECTED"), K());
    }).catch((y) => {
      console.warn(
        `Fetching OAuth status failed for ${a} ${t}`,
        y
      ), m("CONNECTION_FAILED");
    });
  };
  tt(
    () => {
      w >= he ? (m("CONNECTION_TIMEOUT"), K()) : (k(), N(w + 1));
    },
    $ ? d : null
  );
  const F = () => {
    C("settings:view:oauth:started", {
      widgetId: t,
      widgetType: a
    }), fetch(Ee, { ...T }).then((y) => y.json()).then(({ data: y }) => {
      const { url: L } = y, U = 620, Z = 800, ie = window.innerWidth / 2 - U / 2, se = window.innerHeight / 2 - Z / 2;
      m("CONNECTING"), Q(!0), window.open(
        L,
        "DixaPartnerOAuth",
        `toolbar=no,
						location=no,
						status=no,
						menubar=no,
						scrollbars=yes,
						resizable=yes,
						width=${U},
						height=${Z},
						left=${ie},
						top=${se}`
      );
    }).catch((y) => {
      console.warn(
        `Fetching OAuth connection failed for ${a} ${t}`,
        y
      ), m("CONNECTION_FAILED");
    });
  };
  return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsx(te, { span: 3, children: /* @__PURE__ */ s.jsx(
      z,
      {
        label: i,
        meta: {
          warning: "All agents interact with the widget using your access permissions."
        },
        style: { marginBottom: 20 },
        children: /* @__PURE__ */ s.jsxs(W, { flexDirection: "row", alignItems: "baseline", gap: "300", children: [
          /* @__PURE__ */ s.jsx(
            De,
            {
              icon: "key",
              variant: "secondary",
              onClick: F,
              disabled: ae,
              style: { marginBottom: 8 },
              children: "Start authorization"
            }
          ),
          /* @__PURE__ */ s.jsx(Qr, { content: O, children: ae ? /* @__PURE__ */ s.jsx(cr, { "data-testid": "oauth-button-spinner", size: 18 }) : /* @__PURE__ */ s.jsx(
            Ie,
            {
              "data-testid": "oauth-button-status-icon",
              name: x,
              color: g
            }
          ) })
        ] })
      }
    ) }),
    /* @__PURE__ */ s.jsx(te, { span: 3 })
  ] });
}, vr = Jr(null), pn = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  vr.Provider
);
function gr() {
  const r = qr(vr);
  if (r === null)
    throw Error(
      "useWidgetContext requires WidgetContext to be used higher up in the component tree, below WidgetContextProvider"
    );
  return r;
}
const It = "_settingsWrapper_eleyu_1", jt = {
  settingsWrapper: It
}, kt = Pe`
  query getLists {
    Klaviyo {
      get_lists {
        ... on Klaviyo_get_lists_response {
          ... on Klaviyo_GetListListResponseCollectionCompoundDocument {
            data {
              type
              id
              attributes {
                name
                created
                updated
              }
              links {
                self
              }
            }
            links {
              self
            }
          }
          ... on Klaviyo_ClientError_response {
            errors {
              id
              code
              title
              detail
              source {
                pointer
                parameter
              }
            }
          }
          ... on Klaviyo_ServerError_response {
            errors {
              id
              code
              title
              detail
              source {
                pointer
                parameter
              }
            }
          }
        }
      }
    }
  }
`, ir = [], vn = ({
  settings: r,
  getValueByKey: t,
  handleChangeSelect: a
}) => {
  const i = "subscriptionListId", m = r?.find(
    (d) => d.key === i
  )?.label ?? "Activate re-/subscription list selection", C = t(i)?.value, { useQuery: x } = gr(), [g, O] = I(ir), [p, E] = I(!!C), [S, T] = I(C), {
    data: P,
    error: w,
    loading: N
  } = x(kt, {
    skip: !p,
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  return M(() => {
    C && (T(C), E(!0));
  }, [C]), M(() => {
    const d = P?.Klaviyo?.get_lists;
    if (p && d && !N && !w) {
      const b = d?.data?.map(
        ($) => ({
          value: $?.id,
          label: $?.attributes?.name
        })
      ) || ir;
      O(b);
    }
  }, [p, P, N, w]), /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsx(te, { span: 3, children: /* @__PURE__ */ s.jsxs(
      W,
      {
        gap: "300",
        flexDirection: "column",
        className: jt.settingsWrapper,
        children: [
          /* @__PURE__ */ s.jsx(z, { label: m, children: /* @__PURE__ */ s.jsx(
            Zr,
            {
              input: {
                name: `${i}-switch`,
                value: "switchValueFromComponent",
                checked: p,
                onChange: () => {
                  const d = !p;
                  d || a(i, {
                    selectedValues: [
                      {
                        label: "",
                        value: ""
                      }
                    ]
                  }), E(d);
                }
              }
            }
          ) }),
          p && w && !N && /* @__PURE__ */ s.jsx(z, { children: /* @__PURE__ */ s.jsx(Ot, { error: w }) }),
          p && !w && N && /* @__PURE__ */ s.jsx(z, { children: /* @__PURE__ */ s.jsx(W, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ s.jsx(cr, {}) }) }),
          p && !w && !N && g && /* @__PURE__ */ s.jsx(z, { label: "Available lists to subscribe to", children: /* @__PURE__ */ s.jsx(
            Xr,
            {
              required: !0,
              placeholder: "Select a list",
              onChange: (d) => {
                a(i, d), T(d?.selectedValues?.[0].value);
              },
              getItemTitleByValue: (d) => d ? /* @__PURE__ */ s.jsx(ne.Paragraph, { children: d.label }) : null,
              value: S ? [
                {
                  label: (g || []).find(
                    (d) => d.value === S
                  )?.label,
                  value: S
                }
              ] : [],
              equalityFn: (d, b) => d.value === b.value,
              children: g.map((d) => /* @__PURE__ */ s.jsx(et.Item, { value: d, children: d.label }, d.value))
            }
          ) })
        ]
      }
    ) }),
    /* @__PURE__ */ s.jsx(te, { span: 3 })
  ] });
}, gn = (r) => {
  if (r == null)
    return null;
  if (typeof r == "boolean" || r === "true" || r === "false") {
    const i = r === "true" || r === !0;
    return /* @__PURE__ */ s.jsx(
      Ie,
      {
        name: i ? "check-circle-filled" : "close-circle-filled",
        color: i ? B.green[500] : B.red[500],
        size: 14,
        "data-testid": `displayAttributeValue-icon-${i ? "true" : "false"}`
      }
    );
  }
  if (typeof r == "number" || /^\d*\.?\d+$/.test(r))
    return /* @__PURE__ */ s.jsx(Ne, { variant: "success", size: "small", children: r });
  if (r.startsWith("days_ago: ")) {
    const i = r.replace("days_ago: ", ""), u = i.startsWith("-"), m = i === "0", C = u ? `${i.replace("-", "")} days ago` : `in ${i} days`;
    return /* @__PURE__ */ s.jsx(ne.Paragraph, { variant: "5", color: "secondary", children: m ? "today" : C });
  }
  const a = nt(r);
  return a.isValid() ? /* @__PURE__ */ s.jsx(ne.Paragraph, { variant: "5", color: "secondary", children: a.format(St) }) : /* @__PURE__ */ s.jsx(Ne, { variant: "info", size: "small", children: r });
}, Mt = Pe`
  query read($conversationId: String!) {
    Storage {
      widgetData(conversation: $conversationId)
    }
  }
`, Ft = Pe`
  mutation store($conversationId: String!, $data: Storage_JSONObject) {
    Storage {
      storeWidgetData(conversation: $conversationId, data: $data) {
        data
      }
    }
  }
`;
function hn(r) {
  const { useQuery: t, useMutation: a } = gr(), [i, u] = I(), [m, C] = I(), [x, g] = I(!1), {
    loading: O,
    data: p,
    error: E
  } = t(Mt, {
    skip: !r,
    variables: {
      conversationId: r?.toString()
    }
  }), [S, { loading: T, error: P }] = a(Ft), w = async (N, d) => await S({
    variables: {
      conversationId: (d ?? r)?.toString(),
      data: N
    }
  }).then(({ data: $ }) => u($?.Storage?.storeWidgetData?.data ?? {}));
  return M(() => {
    !O && p && u(p?.Storage?.widgetData ?? {});
  }, [p, O]), M(() => E && C(E), [E]), M(() => g(O), [O]), M(() => P && C(P), [P]), M(() => g(T), [T]), {
    data: i,
    loading: x,
    store: w,
    error: m
  };
}
export {
  Ot as DisplayErrors,
  zt as DixaApiTokenSettings,
  vn as KlaviyoSubscribeSetting,
  dn as OAuthSettings,
  pn as WidgetContextProvider,
  cn as capitalizeFirstCharacter,
  un as countryCodes,
  sn as deepClone,
  St as defaultDateFormat,
  gn as displayAttributeValue,
  Pt as getConnectionStatusValues,
  ln as getCountryNameFromCountryCode,
  kt as getListsQuery,
  At as getPartnerDevApiHeaders,
  Qt as hasDixaHeaderCheckError,
  Zt as hasDownstreamApiAuthorizationError,
  nn as hasDownstreamApiBadRequestError,
  tn as hasDownstreamApiConflictError,
  on as hasDownstreamApiForbiddenError,
  rn as hasDownstreamApiNotFoundError,
  Xt as hasDownstreamApiPermissionError,
  en as hasDownstreamApiServiceUnavailableError,
  an as hasDownstreamApiTooManyRequestsError,
  Rt as hasWidgetMisconfiguredError,
  dt as isDixaHeaderCheckError,
  pt as isDownstreamApiAuthorizationError,
  Et as isDownstreamApiBadRequestError,
  mt as isDownstreamApiConflictError,
  yt as isDownstreamApiForbiddenError,
  ht as isDownstreamApiNotFoundError,
  vt as isDownstreamApiPermissionError,
  gt as isDownstreamApiServiceUnavailableError,
  Ct as isDownstreamApiTooManyRequestsError,
  Nt as isRunningLocalPartnerApi,
  bt as isWidgetMisconfiguredError,
  Jt as makeExecuteQuery,
  Ht as makeUseLazyQuery,
  qt as makeUseMutation,
  Kt as makeUseQuery,
  wt as parseAccessToken,
  _t as useCopyWithDelay,
  hn as useData,
  Dt as useTracking,
  gr as useWidgetContext,
  fn as validateApiHostName
};
